<template>
  <layout>
    <rdkm-title>
      {{ $t('Шаблоны писем') }}
    </rdkm-title>
    <div class="tile">      
      <rdkm-grid :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="typeName" :title="$t('Тип')"></grid-column>
        <grid-column name="receiver" :title="$t('Получатель')"></grid-column>
        <grid-column name="subject" :title="$t('Заголовок')"></grid-column>
        <grid-column name="message" :title="$t('Сообщение')" :format="function(val, row) { return val.replace(/<(.|\n)*?>/g, '') }"></grid-column>
        <grid-column name="DELETE" cell="disable-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "MailTemplates",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
